module.exports = __webpack_public_path__ + "static/media/system archi.98bb5894.png";